import { ComboboxPopover, type ComboboxPopoverProps } from '@ariakit/react/combobox';
import { SelectPopover, type SelectPopoverProps } from '@ariakit/react/select';
import cn from 'classnames';
import { Children } from 'react';
import { ComboboxItem } from '../combobox/combobox-item/ComboboxItem.tsx';
import { SelectItem } from '../select-item/SelectItem.tsx';
import styles from './SelectMenu.module.css';

type SelectMenuProps = {
  /** Message to show if no items are available to choose */
  noItemsMessage?: string;
  onBlur?: (event: React.FocusEvent<HTMLDivElement>) => void;
  type: 'select';
} & SelectPopoverProps;

type ComboboxMenuProps = {
  /** Message to show if no items are available to choose */
  noItemsMessage?: string;
  onBlur?: (event: React.FocusEvent<HTMLDivElement>) => void;
  type: 'combobox';
} & ComboboxPopoverProps;

type Props = SelectMenuProps | ComboboxMenuProps;

export function SelectMenu({ children, noItemsMessage = 'No options found', className, ...props }: Props) {
  const hasChildren = Children.count(children);

  if (props.type === 'select') {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Pulling out type so it is not spread into popover.
    const { type, ...restProps } = props;

    return (
      <SelectPopover className={cn(styles.SelectMenu, className)} sameWidth gutter={4} {...restProps}>
        {hasChildren ? children : <SelectItem isMessage={true}>{noItemsMessage}</SelectItem>}
      </SelectPopover>
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Pulling out type so it is not spread into popover.
  const { type, ...restProps } = props;

  return (
    <ComboboxPopover className={cn(styles.SelectMenu, className)} sameWidth gutter={4} {...restProps}>
      {hasChildren ? children : <ComboboxItem isMessage={true}>{noItemsMessage}</ComboboxItem>}
    </ComboboxPopover>
  );
}
